import { render, staticRenderFns } from "./PersonEmailDialog.vue?vue&type=template&id=7abcfd96"
import script from "./PersonEmailDialog.vue?vue&type=script&lang=ts"
export * from "./PersonEmailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports